import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex-1" }
const _hoisted_2 = { class: "text-xl font-semibold text-gray-900 h-16" }
const _hoisted_3 = { class: "mt-0 flex flex-col items-baseline text-gray-900 leading-9" }
const _hoisted_4 = {
  key: 0,
  class: "text-5xl font-extrabold tracking-tight"
}
const _hoisted_5 = {
  role: "list",
  class: "mt-0 lg:mt-4 mb-2 space-y-6"
}
const _hoisted_6 = { class: "flex" }
const _hoisted_7 = { class: "text-gray-500" }


import HardwareImage from './HardwareImage.vue';

type Product = {
  id: string,
  name: string,
  description: string,
  price: number,
  discountedPrice?: number,
  displayDiscount?: boolean,
}


export default /*@__PURE__*/_defineComponent({
  __name: 'HardwareSelectorProductOld',
  props: {
    isSelectedProduct: { type: Boolean },
    product: {}
  },
  emits: ["handle-select-product"],
  setup(__props: any, { emit: __emit }) {



const emit = __emit;

const handleSelectProduct = (product: Product) => {
  emit('handle-select-product', product);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    onClick: _cache[0] || (_cache[0] = ($event: any) => (handleSelectProduct(_ctx.product))),
    class: _normalizeClass(["my-2 lg:my-0 cursor-pointer transition duration-250 relative p-8 bg-white rounded-2xl shadow-sm flex flex-col border border-solid", [_ctx.isSelectedProduct ? 'border-black' : 'border-gray-200']])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h3", _hoisted_2, _toDisplayString(_ctx.product.name.toUpperCase()), 1),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", {
          class: _normalizeClass(['tracking-tight', _ctx.product.displayDiscount ? 'text-decoration-line: line-through text-xl text-gray-300 font-bold' : 'text-5xl text-gray-900 font-extrabold'])
        }, "$" + _toDisplayString(_ctx.product.price), 3),
        (_ctx.product.displayDiscount)
          ? (_openBlock(), _createElementBlock("span", _hoisted_4, "$" + _toDisplayString(_ctx.product.discountedPrice), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("ul", _hoisted_5, [
        _createElementVNode("li", _hoisted_6, [
          _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.product.description), 1)
        ])
      ])
    ]),
    _createElementVNode("button", {
      class: _normalizeClass([('mt-0 lg:mt-3 block w-full py-3 px-6 border border-transparent rounded-md text-center font-medium '), (_ctx.isSelectedProduct ? 'bg-brand-primary text-white' : 'bg-brand-primary-light hover:bg-brand-primary text-brand-secondary')])
    }, _toDisplayString(_ctx.isSelectedProduct ? 'Selected' : 'Select Product'), 3)
  ], 2))
}
}

})